var map = {
	"./Embedded.ActivitySequence.json": 722,
	"./Embedded.Address.json": 5326,
	"./Embedded.Adjustments.json": 6954,
	"./Embedded.BookingPreferences.json": 725,
	"./Embedded.BookingTimes.json": 8637,
	"./Embedded.CarrierProduct.json": 5309,
	"./Embedded.Characteristic.json": 3143,
	"./Embedded.CodeListElement.json": 2949,
	"./Embedded.ContactDetail.json": 5075,
	"./Embedded.CurrencyValue.json": 3434,
	"./Embedded.Dimensions.json": 7099,
	"./Embedded.Geolocation.json": 356,
	"./Embedded.LoosePiece.json": 1282,
	"./Embedded.Measurement.json": 1954,
	"./Embedded.MovementTime.json": 4742,
	"./Embedded.OtherCharge.json": 7892,
	"./Embedded.OtherIdentifier.json": 4355,
	"./Embedded.Party.json": 5802,
	"./Embedded.PieceGroup.json": 8687,
	"./Embedded.Ranges.json": 5284,
	"./Embedded.RegulatedEntity.json": 3046,
	"./Embedded.StationRemarks.json": 2999,
	"./Embedded.TemperatureInstructions.json": 4213,
	"./Embedded.ULDBasicPiece.json": 1345,
	"./Embedded.ULDSpecificPiece.json": 2613,
	"./Embedded.UnitsPreference.json": 6244,
	"./Embedded.Value.json": 771,
	"./Embedded.VolumePieceGroup.json": 197,
	"./Embedded.VolumetricWeight.json": 894,
	"./Embedded.WaybillLineItem.json": 1669
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9785;
module.exports = webpackAsyncContext;